const RiegoCard = ({ value }) => {

  return (
    <>
      <th scope="row">{value.idNodo}</th>
      <td>{value.lat}</td>
      <td>{value.lon}</td>
      <td>{value.turbidez}</td>
      <td>{value.salinidad}</td>
      <td>{value.temperatura}</td>
      <td>{value.fecha}</td>
      <td>{value.hora}</td>
    </>
  )

}

export default RiegoCard